import React, { useEffect } from 'react';
import { getCurrentUser, getProfile, updateProfile, updatePassword } from '../../utils/auth';
import { Form, Input, Button, message, Switch } from 'antd';
import '../Profile/index.css';

export default function SettingsPage() {
  const cur = getCurrentUser();
  const username = cur?.username;
  const [settingsForm] = Form.useForm();
  const [passwordForm] = Form.useForm();

  useEffect(() => {
    if (!username) return;
    const p = getProfile(username) || {};
    settingsForm.setFieldsValue({
      email: p.email || '',
      emailNotifications: typeof p.emailNotifications === 'boolean' ? p.emailNotifications : true,
      pushNotifications: typeof p.pushNotifications === 'boolean' ? p.pushNotifications : false,
      enable2FA: typeof p.enable2FA === 'boolean' ? p.enable2FA : false,
    });
  }, [username, settingsForm]);

  async function onSaveSettings(values) {
    try {
      const payload = {
        email: values.email || '',
        emailNotifications: !!values.emailNotifications,
        pushNotifications: !!values.pushNotifications,
        enable2FA: !!values.enable2FA,
      };
      const res = updateProfile(username, payload);
      if (!res.ok) throw new Error(res.error || '保存失败');
      message.success('设置已保存');
    } catch (err) {
      message.error('保存失败：' + err.message);
    }
  }

  return (
    <div className="container">
      <h1>设置</h1>
      <div className="profile-form">
        <div className="settings-section" style={{ paddingBottom: 8 }}>
          <h3>账户设置</h3>
          <Form form={settingsForm} layout="vertical" onFinish={onSaveSettings} initialValues={{ emailNotifications: true, pushNotifications: false }}>
            <Form.Item name="email" label="邮箱" rules={[{ type: 'email', message: '请输入有效的邮箱地址' }]}>
              <Input placeholder="your@email.example" />
            </Form.Item>

            <Form.Item label="通知设置" style={{ marginBottom: 8 }}>
              <div style={{ display: 'flex', gap: 12 }}>
                <Form.Item name="emailNotifications" valuePropName="checked" style={{ marginBottom: 0 }}>
                  <Switch />
                </Form.Item>
                <div style={{ flex: 1 }}>邮件通知</div>
              </div>
              <div style={{ display: 'flex', gap: 12, marginTop: 8 }}>
                <Form.Item name="pushNotifications" valuePropName="checked" style={{ marginBottom: 0 }}>
                  <Switch />
                </Form.Item>
                <div style={{ flex: 1 }}>推送通知（浏览器/移动端）</div>
              </div>
            </Form.Item>

            <Form.Item label="安全">
              <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
                <Form.Item name="enable2FA" valuePropName="checked" style={{ marginBottom: 0 }}>
                  <Switch />
                </Form.Item>
                <div style={{ flex: 1 }}>启用两步验证（模拟）</div>
              </div>
            </Form.Item>

            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" htmlType="submit">保存设置</Button>
              </div>
            </Form.Item>
          </Form>
        </div>

        <div className="password-section" style={{ marginTop: 16 }}>
          <h3>修改密码</h3>
          <Form form={passwordForm} layout="vertical" onFinish={async (v) => {
            const { oldPassword, newPassword, confirm } = v;
            if (newPassword !== confirm) { message.error('两次输入的新密码不一致'); return; }
            try {
              const res = updatePassword(username, oldPassword, newPassword);
              if (!res.ok) throw new Error(res.error || '修改失败');
              message.success('密码已修改，请使用新密码登录');
              passwordForm.resetFields();
            } catch (err) {
              message.error('修改密码失败：' + err.message);
            }
          }}>
            <Form.Item name="oldPassword" label="旧密码" rules={[{ required: true, message: '请输入旧密码' }]}>
              <Input.Password />
            </Form.Item>
            <Form.Item name="newPassword" label="新密码" rules={[{ required: true, message: '请输入新密码' }, { min: 6, message: '密码至少 6 位' }]}>
              <Input.Password />
            </Form.Item>
            <Form.Item name="confirm" label="确认新密码" rules={[{ required: true, message: '请再次输入新密码' }]}>
              <Input.Password />
            </Form.Item>
            <Form.Item>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" danger htmlType="submit">修改密码</Button>
              </div>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}